(function () {
  function closest(el, selector) {
    if (!el) return null;
    return el.closest ? el.closest(selector) : null;
  }

  function getVariantIdFromUrl() {
    try {
      var params = new URLSearchParams(window.location.search);
      return params.get("variant");
    } catch (e) {
      return null;
    }
  }

  function getCurrentVariantIdFromForm() {
    var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
    return input && input.value ? input.value : null;
  }

  function parseVariantImageMap(galleryRoot) {
    if (!galleryRoot) return {};

    var wrapper = galleryRoot.parentElement || document;
    var mapEl = wrapper.querySelector("[data-dai-variant-image-map]");

    if (!mapEl) {
      mapEl = document.querySelector("[data-dai-variant-image-map]");
    }

    if (!mapEl) return {};

    try {
      return JSON.parse(mapEl.textContent || "{}");
    } catch (e) {
      return {};
    }
  }

  function setActiveThumb(galleryRoot, url) {
    if (!galleryRoot || !url) return;

    var thumbs = galleryRoot.querySelectorAll("[data-dai-thumb-url]");
    thumbs.forEach(function (thumb) {
      if (thumb.getAttribute("data-dai-thumb-url") === url) {
        thumb.classList.add("is-active");
        try {
          thumb.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        } catch (e) {}
      } else {
        thumb.classList.remove("is-active");
      }
    });
  }

  function updateMainImage(galleryRoot, url, direction) {
    if (!galleryRoot || !url) return;

    var mainImage = galleryRoot.querySelector("[data-dai-main-image]");
    if (!mainImage) return;

    if (mainImage.getAttribute("src") !== url) {
      mainImage.style.opacity = '0.7';
      mainImage.style.transition = 'opacity 0.2s ease, transform 0.2s ease';
      mainImage.style.transform = direction === 'next' ? 'translateX(-6px)' : (direction === 'prev' ? 'translateX(6px)' : 'none');

      var newImg = new Image();
      newImg.onload = function () {
        mainImage.setAttribute("src", url);
        mainImage.style.opacity = '1';
        mainImage.style.transform = 'none';
      };
      newImg.onerror = function () {
        mainImage.setAttribute("src", url);
        mainImage.style.opacity = '1';
        mainImage.style.transform = 'none';
      };
      newImg.src = url;
    }

    setActiveThumb(galleryRoot, url);
  }

  function stepGallery(galleryRoot, direction) {
    if (!galleryRoot) return;
    var thumbs = Array.from(galleryRoot.querySelectorAll("[data-dai-thumb-url]"));
    if (thumbs.length <= 1) return;

    var activeIndex = thumbs.findIndex(function (t) { return t.classList.contains("is-active"); });
    if (activeIndex === -1) activeIndex = 0;

    var nextIndex = activeIndex;
    if (direction === 'prev') {
      nextIndex = activeIndex > 0 ? activeIndex - 1 : thumbs.length - 1;
    } else {
      nextIndex = activeIndex < thumbs.length - 1 ? activeIndex + 1 : 0;
    }

    var url = thumbs[nextIndex].getAttribute("data-dai-thumb-url");
    updateMainImage(galleryRoot, url, direction);
  }

  function updateImageForVariant(galleryRoot, variantId) {
    if (!galleryRoot || !variantId) return;

    var map = parseVariantImageMap(galleryRoot);
    var rec = map[String(variantId)];
    var url = rec && rec.primary_image_url;

    if (url) {
      updateMainImage(galleryRoot, url);
    }
  }

  function updateAllGalleriesForCurrentVariant() {
    var variantId = getVariantIdFromUrl() || getCurrentVariantIdFromForm();
    if (!variantId) return;

    document.querySelectorAll("[data-dai-product-gallery]").forEach(function (galleryRoot) {
      updateImageForVariant(galleryRoot, variantId);
    });
  }

  // Bind Touch & Mouse Swipe Gestures to Gallery Main
  function initGalleryTouchGestures(galleryRoot) {
    if (!galleryRoot || galleryRoot._touchInitialized) return;
    galleryRoot._touchInitialized = true;

    var mainContainer = galleryRoot.querySelector(".dai-product-gallery__main");
    if (!mainContainer) return;

    var startX = 0;
    var startY = 0;
    var startTime = 0;
    var isTouching = false;
    var isDragging = false;

    // Mobile Touch
    mainContainer.addEventListener("touchstart", function (e) {
      if (e.touches.length !== 1) return;
      var touch = e.touches[0];
      startX = touch.clientX;
      startY = touch.clientY;
      startTime = Date.now();
      isTouching = true;
    }, { passive: true });

    mainContainer.addEventListener("touchend", function (e) {
      if (!isTouching || e.changedTouches.length !== 1) return;
      isTouching = false;

      var touch = e.changedTouches[0];
      var deltaX = touch.clientX - startX;
      var deltaY = touch.clientY - startY;
      var deltaTime = Date.now() - startTime;

      // Ensure horizontal swipe is dominant and above threshold
      if (Math.abs(deltaX) > 30 && Math.abs(deltaX) > Math.abs(deltaY) * 1.2 && deltaTime < 800) {
        if (deltaX < 0) {
          stepGallery(galleryRoot, 'next');
        } else {
          stepGallery(galleryRoot, 'prev');
        }
      }
    }, { passive: true });

    // Desktop Mouse Drag
    mainContainer.addEventListener("mousedown", function (e) {
      if (e.button !== 0 || e.target.closest('button, a, .dai-gallery-arrow')) return;
      startX = e.clientX;
      startY = e.clientY;
      startTime = Date.now();
      isDragging = true;
    });

    mainContainer.addEventListener("mouseup", function (e) {
      if (!isDragging) return;
      isDragging = false;

      var deltaX = e.clientX - startX;
      var deltaY = e.clientY - startY;
      var deltaTime = Date.now() - startTime;

      if (Math.abs(deltaX) > 35 && Math.abs(deltaX) > Math.abs(deltaY) * 1.2 && deltaTime < 800) {
        if (deltaX < 0) {
          stepGallery(galleryRoot, 'next');
        } else {
          stepGallery(galleryRoot, 'prev');
        }
      }
    });

    mainContainer.addEventListener("mouseleave", function () {
      isDragging = false;
    });
  }

  function initAllGalleries() {
    document.querySelectorAll("[data-dai-product-gallery]").forEach(function (galleryRoot) {
      initGalleryTouchGestures(galleryRoot);
    });
  }

  document.addEventListener("click", function (event) {
    var thumb = closest(event.target, "[data-dai-thumb-url]");
    
    // Handle arrow clicks
    var prevArrow = closest(event.target, ".dai-gallery-arrow--prev");
    var nextArrow = closest(event.target, ".dai-gallery-arrow--next");
    
    if (prevArrow || nextArrow) {
      event.preventDefault();
      event.stopPropagation();
      var arrow = prevArrow || nextArrow;
      var galleryRoot = closest(arrow, "[data-dai-product-gallery]");
      if (!galleryRoot) return;
      
      stepGallery(galleryRoot, prevArrow ? 'prev' : 'next');
      return;
    }

    if (!thumb) return;

    var galleryRoot = closest(thumb, "[data-dai-product-gallery]");
    var url = thumb.getAttribute("data-dai-thumb-url");

    updateMainImage(galleryRoot, url);
  });

  document.addEventListener("change", function () {
    window.setTimeout(updateAllGalleriesForCurrentVariant, 100);
  });

  document.addEventListener("variant:change", function (event) {
    var variant = event.detail && event.detail.variant;

    if (!variant || !variant.id) {
      updateAllGalleriesForCurrentVariant();
      return;
    }

    document.querySelectorAll("[data-dai-product-gallery]").forEach(function (galleryRoot) {
      updateImageForVariant(galleryRoot, variant.id);
    });
  });

  window.addEventListener("popstate", updateAllGalleriesForCurrentVariant);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAllGalleries();
      updateAllGalleriesForCurrentVariant();
    });
  } else {
    initAllGalleries();
    updateAllGalleriesForCurrentVariant();
  }

  // Observer to init touch on dynamically inserted galleries
  if (window.MutationObserver) {
    var observer = new MutationObserver(function () {
      initAllGalleries();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();